import { TFunctionType } from 'shared/entities/localization';

import {
  ActualNameCreator,
  createActualBlockName,
  normalizeCommonFields
} from '../../block/common';

import {
  IActionAddRowGoogleSheetsParams,
  ActionAddRowGoogleSheetsNormalizer
} from './client';

const createActionAddRowGoogleSheetsActualNameBase = (
  tableName: string | null,
  t: TFunctionType
): string => {
  return tableName
    ? t('block.ActionAddRowGoogleSheets.actualName', {
        ns: 'entities',
        tableName
      })
    : '';
};

export const createActionAddRowGoogleSheetsActualName: ActualNameCreator<
  IActionAddRowGoogleSheetsParams
> = ({ params, t }) =>
  createActionAddRowGoogleSheetsActualNameBase(params.table?.name || null, t);

export const normalizeActionAddRowGoogleSheets: ActionAddRowGoogleSheetsNormalizer =
  (raw, stores) => {
    return {
      ...normalizeCommonFields(raw, stores),
      actualName: (t) =>
        createActualBlockName({
          paramsName: createActionAddRowGoogleSheetsActualNameBase(
            raw.params.table_name || null,
            t
          ),
          blockKind: raw.kind,
          blockName: raw.name,
          t,
          ...stores
        })
    };
  };
